import apiClient from 'utilities/apiClient';

export const detailsList = (url, payload) => {
  return apiClient.get(`${apiClient.Urls.listView}/${url}`, payload, true);
  // return apiClient.get(`${apiClient.Urls.list_userView}`, payload, true);
};

export const payment_status = (payload) => {
  return apiClient.get(`${apiClient.Urls.list_userView}`, payload, true);
  // return apiClient.get(`${apiClient.Urls.list_userView}`, payload, true);
};

export const listView = (payload) => {
  return apiClient.get(`${apiClient.Urls.dashboardViwa}`, payload, true);
};

export const list_AIView = (payload) => {
  return apiClient.get(
    `${apiClient.Urls.dashboardAIView}/${payload}`,
    payload,
    true
  );
};

// like_unlike
export const like_unlike = (url, payload) => {
  return apiClient.patch(
    `${apiClient.Urls.user_actions}/${url}`,
    payload,
    true
  );
};
